import React, { useEffect, useRef } from 'react';
import { ListItemText } from '../ListItemText';
import { NavigationDropdownList } from '../../../NavigationDropdownList';
import { RouteDefinition } from '../../../types/types';
import { NavigationItem } from './NavigationItem';
import { AnimatedNavigationItemBorder } from './AnimatedNavigationItemBorder';
import { Flex } from '../../../../../next-components/Flex';
type NavigationItemDropdownData = {
  route: RouteDefinition;
  activeRouteKey: string;
};
type Props = {
  data: NavigationItemDropdownData;
  onMouseEnter: (routeKey: string) => void;
  onMouseLeave: () => void;
};
export const NavigationItemDropdown = ({
  data: {
    route,
    activeRouteKey
  },
  onMouseEnter,
  onMouseLeave
}: Props) => {
  const isActive = activeRouteKey === route.key;
  const prevActiveRef = useRef(false);

  // Announce dropdown state changes to screen readers
  useEffect(() => {
    if (isActive !== prevActiveRef.current) {
      prevActiveRef.current = isActive;
    }
  }, [isActive]);
  const {
    DropdownComponent
  } = route;
  return <Flex height="100%" onMouseEnter={() => onMouseEnter(route.key)} onMouseLeave={onMouseLeave} position={DropdownComponent === NavigationDropdownList ? 'relative' : 'static'} data-sentry-element="Flex" data-sentry-component="NavigationItemDropdown" data-sentry-source-file="NavigationItemDropdown.tsx">
      <NavigationItem key={route.key} data={route} aria-haspopup="true" aria-expanded={isActive} {...route.navigationItemProps} data-sentry-element="NavigationItem" data-sentry-source-file="NavigationItemDropdown.tsx">
        {route.leftIcon}
        <ListItemText mx="8px" position="relative" data-sentry-element="ListItemText" data-sentry-source-file="NavigationItemDropdown.tsx">
          {route.label}

          <AnimatedNavigationItemBorder active={activeRouteKey === route.key} data-sentry-element="AnimatedNavigationItemBorder" data-sentry-source-file="NavigationItemDropdown.tsx" />
        </ListItemText>
        {route.rightIcon}

        {DropdownComponent && <DropdownComponent isActive={isActive} items={route.subRoutes} />}
      </NavigationItem>
    </Flex>;
};